var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377,
    zoomAndPan: "magnify",
    viewBox: "0 0 283.5 283.500005",
    height: 377,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "617ed1fbc5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.816406 34.667969 L 260.148438 34.667969 L 260.148438 56 L 22.816406 56 Z M 22.816406 34.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "970c3e59d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.816406 81.445312 L 260.148438 81.445312 L 260.148438 103 L 22.816406 103 Z M 22.816406 81.445312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc05f61e65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.816406 128.292969 L 260.148438 128.292969 L 260.148438 149 L 22.816406 149 Z M 22.816406 128.292969 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 283 0 L 283 283 L 0 283 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 283 0 L 283 283 L 0 283 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#617ed1fbc5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 249.746094 55.371094 L 33.222656 55.371094 C 27.492188 55.371094 22.851562 50.734375 22.851562 45.019531 C 22.851562 39.300781 27.492188 34.667969 33.222656 34.667969 L 249.746094 34.667969 C 255.476562 34.667969 260.117188 39.300781 260.117188 45.019531 C 260.117188 50.734375 255.476562 55.371094 249.746094 55.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.854748, 248.768605)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.566406 -59.65625 L 74.566406 -6.996094 L 66.308594 -5.507812 L 66.308594 0 L 92.578125 0 L 92.578125 -5.507812 L 85.121094 -6.996094 L 85.121094 -70.554688 L 91.316406 -71.929688 L 91.316406 -77.4375 L 73.648438 -77.4375 L 49.214844 -16.40625 L 24.78125 -77.4375 L 6.082031 -77.4375 L 6.082031 -71.929688 L 12.390625 -70.4375 L 12.390625 -6.996094 L 4.933594 -5.507812 L 4.933594 0 L 29.710938 0 L 29.710938 -5.277344 L 21.453125 -6.996094 L 21.453125 -60.570312 L 46.347656 0 L 50.476562 0 Z M 74.566406 -59.65625 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.359725, 248.768605)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 48.757812 -25.925781 L 51.164062 -29.140625 C 51.164062 -48.984375 42.445312 -57.476562 29.828125 -57.476562 C 15.601562 -57.476562 6.425781 -46.804688 6.425781 -27.992188 C 6.425781 -11.703125 12.621094 1.148438 30.058594 1.148438 C 39.121094 1.148438 45.773438 -1.835938 49.445312 -4.589844 L 47.722656 -10.785156 C 43.9375 -8.949219 39.234375 -6.996094 32.808594 -6.996094 C 20.765625 -6.996094 17.667969 -16.175781 17.667969 -23.402344 L 17.667969 -25.925781 Z M 29.828125 -50.132812 C 35.332031 -50.132812 40.265625 -46.691406 40.265625 -33.269531 L 17.78125 -33.269531 C 17.667969 -46.691406 24.78125 -50.132812 29.828125 -50.132812 Z M 29.828125 -50.132812 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.256755, 248.768605)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.636719 -6.425781 L 4.015625 -5.164062 L 4.015625 0 L 26.269531 0 L 26.269531 -5.164062 L 19.960938 -6.425781 L 19.960938 -46.230469 C 22.828125 -47.035156 30.746094 -48.871094 34.988281 -48.871094 C 41.414062 -48.871094 43.136719 -45.429688 43.136719 -38.660156 L 43.136719 -6.425781 L 36.824219 -5.164062 L 36.824219 0 L 59.082031 0 L 59.082031 -5.164062 L 53.460938 -6.425781 L 53.460938 -41.988281 C 53.460938 -53.230469 44.96875 -57.476562 37.054688 -57.476562 C 31.664062 -57.476562 24.78125 -55.179688 20.878906 -52.425781 C 20.535156 -52.199219 19.730469 -52.3125 19.730469 -52.886719 L 19.960938 -56.328125 L 18.011719 -57.589844 C 13.308594 -56.558594 8.261719 -56.097656 4.359375 -55.984375 L 4.589844 -50.019531 L 9.636719 -49.101562 Z M 9.636719 -6.425781 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.348212, 248.768605)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 43.480469 -3.554688 C 44.625 -4.128906 44.96875 -3.671875 45.199219 -2.753906 L 46.003906 0 L 60 0 L 60 -4.128906 L 54.148438 -6.769531 L 54.148438 -55.984375 L 51.164062 -57.589844 C 46.347656 -56.558594 43.59375 -56.210938 38.316406 -55.984375 L 38.546875 -50.476562 L 43.707031 -49.558594 L 43.707031 -10.785156 C 39.121094 -8.488281 33.5 -6.882812 29.253906 -6.882812 C 23.746094 -6.882812 19.847656 -7.800781 19.847656 -15.832031 L 19.847656 -55.984375 L 17.09375 -57.703125 C 12.273438 -56.671875 9.292969 -56.210938 4.015625 -55.984375 L 4.246094 -50.707031 L 9.40625 -49.675781 L 9.40625 -15.371094 C 9.40625 -3.328125 17.09375 1.148438 25.8125 1.148438 C 30.972656 1.148438 37.167969 -0.34375 43.480469 -3.554688 Z M 43.480469 -3.554688 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#970c3e59d3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 249.746094 102.148438 L 33.222656 102.148438 C 27.492188 102.148438 22.851562 97.515625 22.851562 91.800781 C 22.851562 86.082031 27.492188 81.449219 33.222656 81.449219 L 249.746094 81.449219 C 255.476562 81.449219 260.117188 86.082031 260.117188 91.800781 C 260.117188 97.515625 255.476562 102.148438 249.746094 102.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc05f61e65)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 249.746094 148.996094 L 33.222656 148.996094 C 27.492188 148.996094 22.851562 144.363281 22.851562 138.644531 C 22.851562 132.925781 27.492188 128.292969 33.222656 128.292969 L 249.746094 128.292969 C 255.476562 128.292969 260.117188 132.925781 260.117188 138.644531 C 260.117188 144.363281 255.476562 148.996094 249.746094 148.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.3978f4cb35eaf7c1a051c6cb08784e07.svg";
export { ForwardRef as ReactComponent };